import React from "react";

import { TabContext, TabList, TabListProps } from "@mui/lab";
import { Tab } from "@mui/material";

export interface TabItem {
  value: string;
  label: string;
}

interface Tabs extends TabListProps {
  tabs: TabItem[];
  selectedTabValue: string;
}

export const Tabs: React.FC<Tabs> = ({ tabs, selectedTabValue, ...props }) => {
  return (
    <TabContext value={selectedTabValue}>
      <TabList {...props}>
        {tabs.map((tab) => (
          <Tab key={tab.value} label={tab.label} value={tab.value} />
        ))}
      </TabList>
    </TabContext>
  );
};
